import { SerializedStyles, css } from "@emotion/react";
import styled from "@emotion/styled";

import { DesignToken, SpacingToken } from "@livechat/design-system-react-components";

import { ResponsiveBreakpoint } from "constants/responsive-breakpoint";
import { Column } from "constants/tickets/columns";
import { getColumnWidthsCss } from "helpers/tickets";
import { withVar } from "themes/helpers";

interface ITh {
  column?: Column;
  uppercase?: boolean;
  hasLoader?: boolean;
}

export const Th = styled.th<ITh>`
  position: relative;
  padding: ${({ hasLoader }): string => (hasLoader ? "9px" : "10px")};
  text-align: ${({ column }): string => (column === Column.Checkbox ? "center" : "left")};
  vertical-align: middle;
  font-size: ${({ uppercase }): string => (uppercase ? "12px" : "14px")};
  ${({ uppercase }): string =>
    uppercase
      ? `
        text-transform: uppercase;
        line-height: 14px;
      `
      : ""};
  font-weight: normal;
  color: var(${DesignToken.ContentBasicSecondary});

  ${({ column }): SerializedStyles | string => (column ? getColumnWidthsCss(column) : "")};
`;

interface ITd {
  column: Column;
  withPointer?: boolean;
}

export const Td = styled.td<ITd>`
  ${({ withPointer }): string | null => (withPointer ? "cursor: pointer" : null)};
  position: relative;
  line-height: 1.33;
  vertical-align: middle;
  border-bottom: 1px solid var(${DesignToken.BorderBasicSecondary});
  word-break: break-word;
  word-wrap: break-word;

  ${({ column }): SerializedStyles | string => (column ? getColumnWidthsCss(column) : "")};
`;

export const cellPaddingCss = css`
  padding: ${withVar(SpacingToken.Spacing2)} 10px;

  @media (max-width: ${ResponsiveBreakpoint.Mobile}px) {
    padding: ${withVar(SpacingToken.Spacing2)};
  }
`;
